import React from 'react'
import Link from 'next/link'
import myKnoxLogo from './images/myknox_white.svg'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import styles from './DashboardSidebarContainer.module.scss'

const DashboardSidebarContainer = ({ title, urlPath, children }) => {
  return (
    <div className={styles.dashboardSidebar}>
      <div className={styles.dashboardLogoWrapper}>
        <Link href={encodeURI(urlPath)}>
          <a className={styles.dashboardLogoImg}>
            <img src={myKnoxLogo} alt="My Knox" className="align-top" />
          </a>
        </Link>
        <div className={classNames('text-uppercase', styles.dashboardLogoText, 'mb-0')}>
          <strong>{title}</strong>
        </div>
      </div>
      <div className={styles.dashboardMenuWrapper}>{children}</div>
    </div>
  )
}

DashboardSidebarContainer.propTypes = {
  children: PropTypes.node.isRequired
}

export default DashboardSidebarContainer
